import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 26 16" {...props}>
      <path
        d="M9.75 0.333344L8.66667 3.58334V4.66668H17.3333V3.58334L16.25 0.333344H9.75ZM5.41667 5.75001L4.33333 9.00001V10.0833H21.6667V9.00001L20.5833 5.75001H14.0833L13 9.00001L11.9167 5.75001H5.41667ZM1.08333 11.1667L0 14.4167V15.5H26V14.4167L24.9167 11.1667H18.4167L17.3333 14.4167L16.25 11.1667H9.75L8.66667 14.4167L7.58333 11.1667H1.08333Z"
        fill="#FDFDFD"
      />
    </Svg>
  )
}

export default Icon
